import React, { useState } from 'react';
import { Button } from 'react-bootstrap';
import { Modal } from 'react-bootstrap';
import classes from './TrialstatNoto.module.css';
import MandatoryLabel from './UI/Control/MandatoryLabel';
import SelectList from './UI/Control/SelectList';
import TextArea from './UI/Control/InputTextarea';

const ChartQueryModal = (props) => {
    const [show, setShow] = useState(false);
    const [chartTypes, setChartTypes] = useState([{ Name: 'Bar', Value: 'Bar' }, { Name: 'Pie', Value: 'Pie' }, { Name: 'Line', Value: 'Line' }
        , { Name: 'Bubble', Value: 'Bubble' }, { Name: 'Doughnut', Value: 'Doughnut' }, { Name: 'Polar Area', Value: 'PolarArea' }, { Name: 'Radar', Value: 'Radar' }, { Name: 'Scatter', Value: 'Scatter' }]);
    const handleClose = () => setShow(false);

    const handleShow = () => {
        setShow(true);
    };

    const LaodChartData = (event) => {
        props.LaodChartData(document.getElementById('txtSQLQuery').value, document.getElementById('ddlChartType').value);
        setShow(false);
    };

    return (
        <>
            <button className="btn btn-lg btn-success" type="button" onClick={handleShow}> {props.text} </button>

            <Modal show={show} onHide={handleClose} dialogClassName={classes.TSModalDailog_Fourteen} animation={false} backdrop="static" style={{ marginTop: "140px" }}>
                <Modal.Header className={classes.modalHeader}>
                    <div style={{ width: "100%" }}>
                        <Modal.Title>{props.header}</Modal.Title>
                    </div>
                </Modal.Header>
                <Modal.Body>

                    <div className="row mt-2">
                        <div className="col-sm-12 form-group">
                            <label>Chart Type<MandatoryLabel />:</label>
                            <SelectList id="ddlChartType" dataSource={chartTypes} style={{ marginTop: "5px" }} />
                        </div>
                    </div>
                    <div className="row mt-2">
                        <div className="col-sm-12 form-group">
                            <label>SQL Query<MandatoryLabel />:</label>
                            <TextArea id="txtSQLQuery" rows='10' cols='100' />
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <div className="" style={{ width: "100%" }}>
                        <Button variant="primary" className="btn btn-danger" onClick={handleClose} style={{ float: "right" }}>
                            Close
                            </Button>
                        <Button variant="secondary" className="btn btn-success" onClick={LaodChartData} style={{ marginRight: "10px", float: "right" }}> Load Chart Data </Button>
                    </div>
                </Modal.Footer>
            </Modal>
        </>
    );
}
export default ChartQueryModal;